import { cn } from "@/lib/utils";

const FIREFLIES_LOGO_SRC = "/logos/connectors/fireflies.svg";

type FirefliesLogoProps = {
  className?: string;
};

export function FirefliesLogo({ className }: FirefliesLogoProps) {
  return (
    <img
      src={FIREFLIES_LOGO_SRC}
      alt=""
      aria-hidden
      className={cn("h-12 w-12 object-contain", className)}
    />
  );
}
